import Cookies from "js-cookie"
let CacheKey = {
    TOKEN:'token',
    USER_NAME:'username',
    setMobile:'mobile',
    email:'email'
}
export const getToken = () => {
    return Cookies.get(CacheKey.TOKEN)
  }
  export const setToken = (token) => {
    Cookies.set(CacheKey.TOKEN, token)
  }
  export const removeAll = () => {
    Cookies.remove(CacheKey.TOKEN)
    Cookies.remove(CacheKey.setMobile)
    Cookies.remove(CacheKey.email)
  }
  
  export const setUserName = (userName) => {
    return Cookies.set(CacheKey.USER_NAME, userName)
  }
  
  export const getUserName = () => {
    return Cookies.get(CacheKey.USER_NAME)
  }
  export const setMobile= (mobile) => {
    return Cookies.set(CacheKey.setMobile, mobile)
  }

  export const getMobile = () => {
    return Cookies.get(CacheKey.setMobile)
  }
  export const setEmail= (email) => {
    let email1 = email || ''
    return Cookies.set(CacheKey.email, email1)
  }

  export const getEmail = () => {
    return Cookies.get(CacheKey.email)
  }